import { render, staticRenderFns } from "./connection-error.vue?vue&type=template&id=3b6a5736&scoped=true"
import script from "./connection-error.vue?vue&type=script&lang=js"
export * from "./connection-error.vue?vue&type=script&lang=js"
import style0 from "./connection-error.vue?vue&type=style&index=0&id=3b6a5736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6a5736",
  null
  
)

export default component.exports